import React, { useState } from "react";
import "../styles/faqs.css";

const FAQs = () => {
  const faqData = [
    {
      number: "01",
      title: "What are the important dates for the hackathon?",
      content:
        `The hackathon registrations will ends on 26th Feb. 2025, and the hackathon starts on 28th Feb. 2025 and ends on 01 March 2025. Check our official timeline for detailed schedules and deadlines.`,
    },
    {
      number: "02",
      title: "Is this an online or offline hackathon?",
      content:
        "Innovastra is an Offline hackathon conducted at Arya College of Engineering, Jaipur.",
    },
    {
      number: "03",
      title: "How do I register for the hackathon?",
      content:
        "You can register by filling out the form on our official website [insert website link] before 26th Feb. 2025.",
    },
    {
      number: "04",
      title: "Can I work on a project that I started before the hackathon?",
      content:
        "No, all projects must be started from scratch after the hackathon begins. However, you can use open-source libraries, APIs, and frameworks.",
    },
    {
      number: "05",
      title: "What platforms or technologies can we use?",
      content:
        "You are free to use any programming languages, frameworks, or tools, as long as they align with the hackathon's goals.",
    },
    {
      number: "06",
      title: "What if I face technical issues during the event?",
      content:
        "If you face any technical issues, reach out to our support team.",
    },
    {
      number: "07",
      title: "Where can I stay updated about announcements?",
      content:
        "Follow us on [social media handles] and join our WhatsApp community for real-time updates.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="process">
      <div className="process__container">
        <div className="process__intro intro">
          <h2 className="process__title">Frequently Asked Questions's</h2>

        </div>

        <div className="process__accordions">
          <ul className="accordions__list">
            {faqData.map((faq, index) => (
              <li
                key={index}
                className={`accordions__item ${openIndex === index ? "open" : ""}`}
              >
                <button
                  className="accordions__control"
                  aria-expanded={openIndex === index}
                  onClick={() => toggleAccordion(index)}
                >
                  <span className="accordions__number">{faq.number}</span>
                  <span className="accordions__title">{faq.title}</span>
                  <span className="accordions__icon"></span>
                </button>

                <div
                  className="accordions__content text"
                  aria-hidden={openIndex !== index}
                  style={{
                    maxHeight: openIndex === index ? "200px" : "0",
                    overflow: "hidden",
                    transition: "max-height 0.5s ease",
                  }}
                >
                  <p>{faq.content}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default FAQs;
